import { ajaxController } from './controller/AjaxController'
import type { SyncRequest, SyncResponse } from '../DTOs/Sync/SyncDtos'

class SyncAjax {
  async sync(request: SyncRequest) {
    return ajaxController.post<SyncRequest, SyncResponse>('/Sync', request)
  }
}

export const syncAjax = new SyncAjax()
